/*
 * @Author: Shann
 * @LastEditors: Shann
 * @Date: 2021-03-19 15:38:09
 * @LastEditTime: 2021-04-06 11:07:33
 * @FilePath: \buyer-one\dop-webapp\src\index.js
 */
import "./init";
import React from "react";
import ReactDOM from "react-dom";
import {
    BrowserRouter as Router, 
    Redirect,
    Route,
    Switch,
} from "react-router-dom";
import LoginPage from "./pages/Login/Login";
// import AppPage from "./pages/App/App";
import AppPage from "./pages/App/AppPro.js";
import Auth from "./utils/auth";
import Lang from "./components/Lang/Lang";

/** React 的全局挂载，避免重复引用
 * start*/
import '@assets/css/data-flex.css';
import '@assets/css/base.less';
// import "./index.less";
// import request from "@utils/request"
// React.Component.prototype.Lang = Lang // 这个可以考虑
// React.Component.prototype.$http = request
/** end*/

class Index extends React.Component {
    render() {
        document.title = Lang({
            id: "EGuoYunYingPingTai",
            default: "ЭЛИТИМ运营平台",
        });
        return (
            <Router>
                <Switch>
                    <Route path="/login">
                        <LoginPage />
                    </Route>
                    <Route path="/">
                        <AppPage />
                    </Route>
                </Switch>
                {!Auth.isLoggedIn() && <Redirect to="/login" />}
            </Router>
        );
    }
}

ReactDOM.render(<Index/>, document.getElementById("essa-dop"));
